import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animate a set of elements with stagger when they enter the viewport
 * @param {string|HTMLElement} target - selector or element container
 * @param {object} options - gsap options (duration, y, opacity, stagger etc)
 */
export function animateOnScroll(target, options = {}) {
  const defaultOpts = {
    y: 30,
    opacity: 0,
    duration: 0.6,
    stagger: 0.1,
    ease: "power2.out",
  };

  const opts = { ...defaultOpts, ...options };

  gsap.from(target, {
    scrollTrigger: {
      trigger: target,
      start: "top 80%",
      toggleActions: "play none none none",
    },
    y: opts.y,
    opacity: opts.opacity,
    duration: opts.duration,
    stagger: opts.stagger,
    ease: opts.ease,
  });
}
